export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_MONTH_YEAR = 'MM/YYYY';
export const SERVER_FORMAT = 'DD/MM/YYYY';
